import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import GeneralInformationPage from "./pages/GeneralInformationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import HomePageOne from "./pages/HomePageOne";
import LanguagePage from "./pages/LanguagePage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import UsersListPage from "./pages/UsersListPage";
import AddAdminUser from "./pages/AdminUserListPage";
import UserListReport from "./pages/UserListReportPage";
import DiseasePage from "./pages/DiseasePage";
import PestPage from "./pages/PestPage";
import PestMappingPage from "./pages/PestMappingPage";
import DiseaseMappingPage from "./pages/DiseaseMappingPage";
import CropMaster from "./pages/CropMasterPage";
import ChangePassword from "./pages/ChangePassword";
import PhasesListPage from "./pages/PhasesListPage";
import SubjectPage from "./pages/SubjectPage";
import CountryPage from "./pages/CountryPage";
import LivestockPage from "./pages/LiveStockPage";
import HumanHealthPage from "./pages/HumanHealthpage";
import CropWiseCommonInformationPage from "./pages/CropWiseCommonInformationPage";
import CropWisePrePostSowingPage from "./pages/CropWisePrePostSowingPage";
import MasterLayout from "./masterLayout/MasterLayout";
import ProtectedRoute from "./helper/ProtectedRoute";
import CampaignManagement from "./pages/CampaignManagement";
import CampaignPage from "./pages/CampaignPage";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ToastContainer autoClose={3000} />
      {/* <MasterLayout> */}
        <Routes>
          <Route element={<ProtectedRoute><MasterLayout /></ProtectedRoute>}>
          <Route exact path='/user-list-report' element={<UserListReport />} />
          <Route  exact path='/' element={<HomePageOne />} />
          <Route exact path='/cropwise-sowing' element={<CropWisePrePostSowingPage />} />
          <Route exact path='/cropwise-info' element={<CropWiseCommonInformationPage />} />
          <Route exact path='/human-health' element={<HumanHealthPage />} />
          {/* <Route exact path='/campaign' element={<CampaignManagement />} /> */}
          <Route path="/campaigns" element={<CampaignPage />} />
          <Route exact path='/livestock' element={<LivestockPage />} />
          <Route exact path="/subject" element={<SubjectPage />} />
          <Route exact path='/disease' element={<DiseasePage />} />
          <Route exact path='/pest' element={<PestPage />} />
          <Route exact path='/pest-mapping' element={<PestMappingPage />} />
          <Route exact path="/general-information" element={<GeneralInformationPage />} />
          <Route exact path='/crop-master' element={<CropMaster />} />
          <Route exact path='/disease-mapping' element={<DiseaseMappingPage />} />
          <Route exact path="/phases" element={<PhasesListPage />} />
          <Route exact path='/admin-user' element={<AddAdminUser />} />
          <Route exact path='/country' element={<CountryPage />} />
          <Route exact path='/farmer-list' element={<UsersListPage />} />
          <Route exact path='/language' element={<LanguagePage />} />
          </Route>


          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/change-password" element={<ChangePassword />} />

          {/* SL */}
          
          <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
          <Route exact path='/sign-up' element={<SignUpPage />} />
        </Routes>
      {/* </MasterLayout> */}
    </BrowserRouter>
  );
}

export default App;
